<div routerLink="{{link}}" [class.active]="active" class="container"
 [class.msp]="text === 'Tenants'" matRipple [matRippleCentered]="true">
  <div class="icon">
    <mat-icon inline>{{icon}}</mat-icon> <!-- fontSet="material-icons-outlined" -->
  </div>
  <div class="text">{{text}}</div>
</div>